
import React, { useEffect, useState, useRef } from 'react';
import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart, DeleteOutline, Close } from '@mui/icons-material';
import { BsInfoCircleFill } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

Modal.setAppElement('#root');

// Invoice Component - Displayed inside Cart Section
const InvoiceComponent = ({ orderData, onOrderAgain }) => {
    if (!orderData) return null;

    const items = orderData.order || [];

    const downloadPDF = async () => {
        const element = document.getElementById('invoice-content');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, { scale: 2, logging: false });
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            pdf.save(`invoice_${orderData.orderId}.pdf`);
            toast.success("PDF downloaded successfully!");
        } catch (error) {
            console.error("PDF download failed:", error);
            toast.error("Failed to download PDF");
        }
    };

    const printInvoice = () => {
        const printContent = document.getElementById('invoice-content');
        if (!printContent) return;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Invoice ${orderData.orderId}</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        @media print {
                            body { padding: 0; }
                            button { display: none; }
                        }
                    </style>
                </head>
                <body>
                    ${printContent.innerHTML}
                    <script>
                        window.onload = () => {
                            window.print();
                            window.onafterprint = () => window.close();
                        }
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div style={{ borderRadius: '12px', }}>
            <div id="invoice-content" style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '14px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
                {/* Header */}
                <div style={{ textAlign: 'center', borderBottom: '2px dashed #ddd', paddingBottom: '15px', marginBottom: '15px' }}>
                    <h2 style={{ margin: 0, color: '#ee6521', fontSize: '18px' }}>{orderData.vendorRegisteredName || 'RESTAURANT'}</h2>
                    <p style={{ fontSize: '10px', color: '#666', margin: '5px 0' }}>{orderData.vendorFullAddress || ''}</p>
                    <p style={{ fontSize: '10px', color: '#666', margin: '0' }}>Ph: {orderData.vendorPhone || 'N/A'}</p>
                    <h4 style={{ margin: '10px 0 0', color: '#333', fontSize: '13px' }}>TAX INVOICE</h4>
                </div>

                {/* Order Info */}
                <div style={{ marginBottom: '15px', fontSize: '11px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Order #:</span>
                        <span>{orderData.orderId}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Date:</span>
                        <span>{orderData.date} {orderData.time}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Customer:</span>
                        <span>{orderData.userName || 'WALK-IN'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Type:</span>
                        <span>{orderData.orderType || 'DINE IN'}</span>
                    </div>
                </div>

                <div style={{ borderTop: '1px dashed #ddd', margin: '10px 0' }}></div>

                {/* Items Table */}
                <table style={{ width: '100%', margin: '15px 0', fontSize: '11px' }}>
                    <thead>
                        <tr style={{ borderBottom: '1px dotted #ddd' }}>
                            <th style={{ textAlign: 'left', padding: '5px 0' }}>ITEM</th>
                            <th style={{ textAlign: 'center', padding: '5px 0' }}>QTY</th>
                            <th style={{ textAlign: 'right', padding: '5px 0' }}>PRICE</th>
                            <th style={{ textAlign: 'right', padding: '5px 0' }}>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={idx}>
                                <td style={{ padding: '6px 0', textAlign: 'left' }}>{(item.productName || item.name || 'Item').substring(0, 20)}</td>
                                <td style={{ padding: '6px 0', textAlign: 'center' }}>{item.quantity || 1}</td>
                                <td style={{ padding: '6px 0', textAlign: 'right' }}>₹{(item.price || 0).toFixed(2)}</td>
                                <td style={{ padding: '6px 0', textAlign: 'right' }}>₹{((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div style={{ borderTop: '1px dashed #ddd', margin: '10px 0' }}></div>

                {/* Totals */}
                <div style={{ marginTop: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px' }}>
                        <span>Subtotal:</span>
                        <span>₹{orderData.subTotal?.toFixed(2) || '0.00'}</span>
                    </div>
                    {orderData.cgst > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px' }}>
                            <span>CGST ({orderData.cgst}%):</span>
                            <span>₹{((orderData.subTotal || 0) * (orderData.cgst || 0) / 100).toFixed(2)}</span>
                        </div>
                    )}
                    {orderData.sgst > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px' }}>
                            <span>SGST ({orderData.sgst}%):</span>
                            <span>₹{((orderData.subTotal || 0) * (orderData.sgst || 0) / 100).toFixed(2)}</span>
                        </div>
                    )}
                    {orderData.packingCharges > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px' }}>
                            <span>Packing Charges:</span>
                            <span>₹{orderData.packingCharges?.toFixed(2)}</span>
                        </div>
                    )}
                    {orderData.deliveryCharges > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px' }}>
                            <span>Delivery Charges:</span>
                            <span>₹{orderData.deliveryCharges?.toFixed(2)}</span>
                        </div>
                    )}
                    {orderData.discountAmount > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px', color: '#22c55e' }}>
                            <span>Discount:</span>
                            <span>-₹{orderData.discountAmount?.toFixed(2)}</span>
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 4px', fontSize: '14px', fontWeight: 'bold', borderTop: '2px solid #ddd', marginTop: '5px' }}>
                        <span>TOTAL:</span>
                        <span style={{ color: '#ee6521' }}>₹{orderData.totalAmount?.toFixed(2) || '0.00'}</span>
                    </div>
                </div>

                <div style={{ borderTop: '1px dashed #ddd', margin: '15px 0' }}></div>

                {/* Payment Info */}
                <div style={{ fontSize: '10px', marginBottom: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Payment Method:</span>
                        <span>{orderData.paymentMethod || 'N/A'}</span>
                    </div>
                    {orderData.transactionId && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                            <span style={{ fontWeight: 'bold' }}>Transaction ID:</span>
                            <span style={{ fontSize: '9px' }}>{orderData.transactionId}</span>
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'bold' }}>Status:</span>
                        <span style={{ color: '#22c55e' }}>{orderData.status || 'COMPLETED'}</span>
                    </div>
                </div>

                {/* Footer */}
                <div style={{ textAlign: 'center', borderTop: '1px dashed #ddd', paddingTop: '15px', marginTop: '10px', fontSize: '9px', color: '#888' }}>
                    <div>** Thank you! Visit Again **</div>
                    <div>GST: {orderData.vendorGstIn || 'N/A'}</div>
                    <div>{new Date().toLocaleString()}</div>
                </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'center' }}>
                <button
                    onClick={downloadPDF}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#22c55e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '11px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    Download PDF
                </button>
                <button
                    onClick={printInvoice}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#ee6521',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '11px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    Print
                </button>
                <button
                    onClick={onOrderAgain}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#3b82f6',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '11px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

const MenuitemsTable = ({ setShowLogin,  searchQuery, items }) => {
    const [dishes, setDishes] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [description, setDescription] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [favorites, setFavorites] = useState([]);

    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("ALL");

    const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
    const [cartRefresh, setCartRefresh] = useState(false);

    const [subTotal, setSubTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [gstTotal, setGstTotal] = useState(0);
    const [platformCharges, setPlatformCharges] = useState(0);
    const [packingCharges, setPackingCharges] = useState(0);
    const [deliveryCharges, setDeliveryCharges] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    // GST Popup State
    const [showGstPopup, setShowGstPopup] = useState(false);
    const [gstBreakdownData, setGstBreakdownData] = useState(null);

    const [discountFilter, setDiscountFilter] = useState("Offers");
    const [couponFilter, setCouponFilter] = useState("Coupons");

    // Payment states
    const [orderType, setOrderType] = useState("DELIVERY");
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [selectedwalletTypes, setSelectedwalletTypes] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);
    const [userProfile, setUserProfile] = useState(null);
    const [orderPlacing, setOrderPlacing] = useState(false);

    // Address states
    const [showAddressPopup, setShowAddressPopup] = useState(false);
    const [selectedAddressObj, setSelectedAddressObj] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [address, setAddress] = useState("");
    const [showAddAddressForm, setShowAddAddressForm] = useState(false);
    const [addressForm, setAddressForm] = useState({
        doorNumber: "", addressLine: "", landMark: "", city: "", state: "", pincode: "", name: "", phoneNumber: "", latitude: null, longitude: null, category: "Home"
    });
    const [isLocating, setIsLocating] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
    const [mapInitialized, setMapInitialized] = useState(false);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const searchInputRef = useRef(null);

    // Schedule order states
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleTime, setScheduleTime] = useState("");
    const [scheduledOrderDetails, setScheduledOrderDetails] = useState(null);

    // Invoice state - displayed in cart section
    const [completedOrderData, setCompletedOrderData] = useState(null);

    const [isAddressValidForDelivery, setIsAddressValidForDelivery] = useState(false);
    const [appliedCoupon, setAppliedCoupon] = useState(false);
    const [couponId, setCouponId] = useState(null);

  
   const [parentId, setParentId] = useState(null);
   const [allDishes, setAllDishes] = useState([]);


    const paymentSectionRef = useRef(null);

    const GOOGLE_MAPS_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";

    const walletTypesMap = {
        "Self Loaded": "SELF_LOADED",
        "Company Loaded": "COMPANY_LOADED",
        "Cashback": "CASHBACK",
    };

    const getAuthVars = () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const customerId = localStorage.getItem("customerId");
        const cartId = localStorage.getItem("cartId");
        return { userId, token, customerId, cartId };
    };

    // Handle GST Popup
    const handleShowGST = async () => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) {
            toast.error("Please login to view GST details");
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            const data = response.data;
            let gstData;

            if (Array.isArray(data) && data.length > 0) {
                const firstItem = data[0];
                gstData = {
                    serviceChargeGst: firstItem.serviceChargeGst || 0,
                    platformChargeGst: firstItem.platformChargeGst || 0,
                    cgst: firstItem.cgst || 0,
                    sgst: firstItem.sgst || 0,
                    gstPercentage: firstItem.gstPercentage || 18
                };
            } else if (data && typeof data === 'object') {
                gstData = {
                    serviceChargeGst: data.serviceChargeGst || 0,
                    platformChargeGst: data.platformChargeGst || 0,
                    cgst: data.cgst || 0,
                    sgst: data.sgst || 0,
                    gstPercentage: data.gstPercentage || 18
                };
            } else {
                gstData = {
                    serviceChargeGst: 0,
                    platformChargeGst: 0,
                    cgst: 0,
                    sgst: 0,
                    gstPercentage: 18
                };
            }

            setGstBreakdownData(gstData);
            setShowGstPopup(true);
        } catch (err) {
            console.error("Error fetching GST data:", err);
            toast.error("Failed to fetch GST details");
        }
    };

    // Handle window resize for mobile view
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setIsCartPanelOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // ==================== FETCH WALLET DATA ====================
    const fetchWalletData = async () => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                { headers: { Authorization: `Bearer ${token}`, Accept: "*/*", "Content-Type": "application/json" } }
            );
            const data = response.data;
            setAvailableBalance(data.totalBalance || 0);
            setAvailableCompany(data.companyLoadedAmount || 0);
            setAvailableSelf(data.selfLoadedAmount || 0);
            setAvailableCashback(data.cashbackAmount || 0);
        } catch (error) {
            console.error("Wallet API Error:", error);
        }
    };

    // ==================== FETCH ADDRESSES ====================
    const fetchAddresses = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId || !token) return;

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/user/location/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const sortedAddresses = response.data.sort((a, b) => {
                const order = { 'Home': 1, 'Office': 2, 'Other': 3 };
                return (order[a.category] || 4) - (order[b.category] || 4);
            });
            setAddresses(sortedAddresses);

            const lastAddress = localStorage.getItem("lastDeliveryAddress");
            if (lastAddress && !selectedAddressObj) {
                const parsed = JSON.parse(lastAddress);
                setSelectedAddressObj(parsed);
                setIsAddressValidForDelivery(true);
            }
        } catch (error) {
            console.error("Failed to fetch addresses", error);
        }
    };

    // ==================== FETCH CATEGORIES ====================
   useEffect(() => {
    const fetchCategories = async () => {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        setCategoriesLoading(true);

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/dish/dish/getall/categeory?userId=${userId}&parentId=null`
            );

            if (Array.isArray(response.data)) {
                setCategories(response.data);
                console.log("✅ Categories loaded:", response.data.length);
                console.log("Sample category:", response.data[0]);
            } else {
                console.error("Categories response is not an array:", response.data);
                setCategories([]);
            }

        } catch (error) {
            console.error("Error fetching categories:", error);
            setCategories([]);
        } finally {
            setCategoriesLoading(false);
        }
    };

    fetchCategories();
    fetchAddresses();
}, []);

// FIX 5: Debug useEffect to verify dish-category mapping
useEffect(() => {
    if (allDishes.length > 0 && categories.length > 0) {
        console.log("=== Debug Mapping ===");
        console.log("Total dishes:", allDishes.length);
        console.log("Total categories:", categories.length);
        
        // Check if dishes have parentId matching category dishId
        const firstDish = allDishes[0];
        const firstCategory = categories[0];
        
        if (firstDish && firstCategory) {
            console.log("Sample dish parentId:", firstDish.parentId);
            console.log("Sample category dishId:", firstCategory.dishId);
            console.log("Do they match?", Number(firstDish.parentId) === Number(firstCategory.dishId));
        }
        
        // Count dishes per category
        categories.forEach(cat => {
            const count = allDishes.filter(dish => 
                Number(dish.parentId) === Number(cat.dishId) && 
                dish.menuStatus === "Enable"
            ).length;
            console.log(`${cat.categoryName}: ${count} dishes`);
        });
    }
}, [allDishes, categories]);

// FIX 4: Log categories when they update
useEffect(() => {
    if (!Array.isArray(allDishes)) return;

    let filtered = [...allDishes];

    // ✅ Category Filter - FIXED LOGIC
    if (selectedCategory !== "ALL") {
        const selectedCat = categories.find(c => c.categoryName === selectedCategory);
        if (selectedCat) {
            filtered = filtered.filter(item => 
                Number(item.parentId) === Number(selectedCat.dishId)
            );
        }
    }
    // If "ALL", show ALL enabled dishes (no parentId filter)

    // ✅ Search Filter
    const searchValue = searchTerm?.toLowerCase().trim() || "";
    if (searchValue !== "") {
        filtered = filtered.filter(
            item =>
                item?.dishName &&
                item.dishName.toLowerCase().includes(searchValue)
        );
    }

    // ✅ Only Enabled Items
    filtered = filtered.filter(item => item?.menuStatus === "Enable");

    setFilteredDishes(filtered);
    setDishes(filtered);

}, [selectedCategory, searchTerm, allDishes, categories]); // Add all dependencies

// FIX 3: Updated handleCategoryClick
const handleCategoryClick = (cat) => {
    console.log("Category clicked:", cat);
    
    // Update selected category
    setSelectedCategory(cat.categoryName);
    
    // Reset other filters
    setIsVegSelected(false);
    setIsNonVegSelected(false);
    
    // Optional: Clear search when changing category
    // setSearchTerm("");
};
    // Main filter effect
    useEffect(() => {
        let filtered = Array.isArray(dishes) ? [...dishes] : [];

        const searchValue = (searchTerm ?? "").toLowerCase().trim();
        if (searchValue !== "") {
            filtered = filtered.filter((dish) => {
                const name = typeof dish?.dishName === "string" ? dish.dishName : "";
                return name.toLowerCase().includes(searchValue);
            });
        }

        if (selectedCategory !== "ALL") {
            filtered = filtered.filter((dish) => dish?.categoryName === selectedCategory);
        }

        if (isVegSelected) {
            filtered = filtered.filter((dish) => dish?.tag === "Veg");
        } else if (isNonVegSelected) {
            filtered = filtered.filter((dish) => dish?.tag === "Non_Veg");
        }

        setFilteredDishes(filtered);
    }, [searchTerm, isVegSelected, isNonVegSelected, dishes, selectedCategory]);

    const handleFilterClick = (type) => {
        if (type === "ALL") { setIsVegSelected(false); setIsNonVegSelected(false); setSearchTerm(""); return; }
        if (type === "Veg") { setIsVegSelected(true); setIsNonVegSelected(false); }
        else if (type === "Non-Veg") { setIsVegSelected(false); setIsNonVegSelected(true); }
    };

    const handleToggleTooltip = (dishId, desc) => {
        if (activeTooltip === dishId) { setActiveTooltip(null); setDescription(""); }
        else { setActiveTooltip(dishId); setDescription(desc || ""); }
    };

    // ==================== FAVORITES ====================
    const handleAddToFavorites = async (dishId) => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId || !token) {
            alert("Please log in to add items to favorites.");
            return;
        }

        const dish = dishes.find(d => d.dishId === dishId);
        if (!dish) {
            alert(`Dish not found!`);
            return;
        }

        if (favorites.includes(dishId)) {
            alert(`❤️ "${dish.dishName}" already in favorites!`);
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const text = await response.text();

            if (response.ok) {
                setFavorites(prev => [...prev, dishId]);
                alert(`✅ "${dish.dishName}" added to favorites!`);
            }
            else if (response.status === 409) {
                setFavorites(prev => [...new Set([...prev, dishId])]);
                alert(`❤️ Already in favorites!`);
            }
            else {
                console.error("Server Error:", text);
                alert("❤️ Already in favorites!");
            }

        } catch (error) {
            console.error("Network error:", error);
            alert("❌ Network error.");
        }
    };

    const handleRemoveCoupon = async () => {
        try {
            const cartId = localStorage.getItem("cartId");
            const token = localStorage.getItem("authToken");

            if (!cartId || !couponId) {
                toast.error("No applied coupon found!");
                return;
            }

            const body = {
                id: Number(couponId),
                applyCoupon: "NOT_APPLIED"
            };

            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("Coupon removed:", response.data);

            setAppliedCoupon(false);
            setDiscountAmount(0);
            setCouponId(null);

            await fetchCartDetails();
            toast.success("Coupon removed successfully!");

        } catch (error) {
            console.error("Failed to remove coupon:", error.response?.data || error.message);
            toast.error("Failed to remove coupon");
        }
    };

    const handleApplyCoupon = async (couponCode) => {
        try {
            const cartId = localStorage.getItem("cartId");
            const token = localStorage.getItem("authToken");

            if (!cartId) {
                toast.error("Cart not found");
                return;
            }

            const body = {
                couponCode: couponCode,
                applyCoupon: "APPLIED"
            };

            const response = await axios.post(
                `https://backend.maamaas.com/food/api/cart/apply/coupon/${cartId}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            const data = response.data;

            if (data.success || data.message === "Coupon applied successfully") {
                setAppliedCoupon(true);
                setDiscountAmount(data.discountAmount || 0);
                setCouponId(data.couponId || data.id);

                await fetchCartDetails();
                toast.success(`Coupon applied! You saved ₹${(data.discountAmount || 0).toFixed(2)}`);
            } else {
                toast.error(data.message || "Failed to apply coupon");
            }

        } catch (err) {
            console.error("Error applying coupon:", err);
            toast.error(err.response?.data?.message || "Failed to apply coupon");
        }
    };

    // ==================== FETCH CART DETAILS ====================
    const fetchCartDetails = async () => {
        const { userId, token } = getAuthVars();
        if (!userId) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            let cartData = response.data;
            if (Array.isArray(cartData) && cartData.length > 0) cartData = cartData[0];
            if (cartData?.cartId) localStorage.setItem("cartId", cartData.cartId);
            const cartItemsList = cartData?.cartItems || [];
            setCartItems(cartItemsList);
            const initialQuantities = {};
            cartItemsList.forEach(item => { initialQuantities[item.itemId] = item.quantity || 1; });
            setQuantities(initialQuantities);
            setSubTotal(cartData?.subtotal || 0);
            setTotal(cartData?.total || 0);
            setGstTotal(cartData?.gstTotal || 0);
            setPlatformCharges(cartData?.platformCharges || 0);
            setServiceCharges(cartData?.serviceCharges || 0);
            setPackingCharges(cartData?.packingTotal || 0);
            setDeliveryCharges(cartData?.deliveryCharges || 0);
            setDiscountAmount(cartData?.discountAmount || 0);
            setAppliedCoupon((cartData?.discountAmount || 0) > 0);
            setGrandTotal(cartData?.grandTotal || 0);
            if (cartData?.orderType) setOrderType(cartData.orderType);
        } catch (err) {
            console.error("Error fetching cart details:", err);
            setCartItems([]);
            setQuantities({});
        }
    };

    // ==================== ADD TO CART ====================
    const addToCart = async (item, quantity = 1, isScheduled = false) => {
        const { userId, token, customerId } = getAuthVars();
        if (!userId) { setShowLogin(true); return; }
        if (!token) { toast.error("Please log in to add items to cart."); return; }
        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/cart/add/item?userId=${userId}&customerId=${customerId}&sheduleorder=${isScheduled}`,
                { dishId: item?.dishId, quantity },
                { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200 || response.status === 201) {
                await fetchCartDetails();
                setCartRefresh(prev => !prev);
                if (window.innerWidth <= 768) setIsCartPanelOpen(true);
                toast.success(`${item.dishName} added to cart!`);
            }
        } catch (error) {
            if (error.response?.status === 401) { toast.error("Session expired. Please login again."); setShowLogin(true); }
            else toast.error(error.response?.data?.message || "Failed to add item");
        }
    };

    // ==================== INCREMENT / DECREMENT ====================
    const incrementQuantity = async (item) => {
        const { userId, token } = getAuthVars();
        if (!item?.itemId) return;
        const newQuantity = (quantities[item.itemId] || item.quantity || 1) + 1;
        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
                null,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (response.status === 200) {
                setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
                await fetchCartDetails();
            }
        } catch (err) { toast.error("Failed to update quantity"); }
    };

    const decrementQuantity = async (item) => {
        const { userId, token } = getAuthVars();
        if (!item?.itemId) return;
        const currentQty = quantities[item.itemId] || item.quantity || 1;
        if (currentQty === 1) {
            await removeCartItem(item);
            return;
        }
        const newQuantity = currentQty - 1;
        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
                null,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (response.status === 200) {
                setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));
                await fetchCartDetails();
            }
        } catch (err) { toast.error("Failed to update quantity"); }
    };

    const removeCartItem = async (item) => {
        const { userId, token } = getAuthVars();
        if (!item?.itemId) return;
        try {
            const response = await axios.delete(
                `https://backend.maamaas.com/food/api/cart/remove/item?userId=${userId}&itemId=${item.itemId}`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (response.status === 200) {
                await fetchCartDetails();
                toast.success(`${item.dishName} removed from cart`);
            }
        } catch (err) {
            toast.error("Failed to remove item");
        }
    };

    // ==================== DISH CARD +/- ====================
    const increaseQuantity = async (dishId, item) => {
        const { userId } = getAuthVars();
        if (!userId) { toast.error("Please log in first."); return; }
        const cartItem = cartItems.find(ci => ci.dishId === dishId);
        if (cartItem) await incrementQuantity(cartItem);
        else await addToCart(item, 1);
    };

    const decreaseQuantity = async (item) => {
        const { userId } = getAuthVars();
        if (!userId || !item.dishId) return;
        const cartItem = cartItems.find(ci => ci.dishId === item.dishId);
        if (cartItem) await decrementQuantity(cartItem);
    };

    // ==================== CLEAR CART ====================
    const handleClearCart = async () => {
        const { userId, token } = getAuthVars();
        if (!userId) { toast.error("User ID not found!"); return; }
        try {
            const response = await axios.delete(
                `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
                { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200) {
                toast.success("Cart cleared successfully!");
                setCartItems([]);
                setQuantities({});
                setGrandTotal(0);
                setSubTotal(0);
                setGstTotal(0);
                setDiscountAmount(0);
                setAppliedCoupon(false);
                setCouponId(null);
                setShowPaymentOptions(false);
                setSelectedPaymentMethod(null);
                setSelectedwalletTypes(null);
                localStorage.removeItem("cartId");
                await fetchCartDetails();
                if (isMobile) setIsCartPanelOpen(false);
            }
        } catch (error) {
            toast.error("Failed to clear cart");
        }
    };

    // ==================== GOOGLE MAPS FUNCTIONS ====================
    const extractAddressFields = (components = []) => {
        const get = (type) => components.find(c => c.types.includes(type))?.long_name || "";
        return {
            city: get("locality") || get("administrative_area_level_2"),
            state: get("administrative_area_level_1"),
            pincode: get("postal_code"),
        };
    };

    const moveMap = (lat, lng) => {
        setLatitude(lat);
        setLongitude(lng);
        setAddressForm(prev => ({
            ...prev,
            latitude: lat,
            longitude: lng
        }));

        if (mapRef.current && mapRef.current.setCenter) {
            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(16);
        }

        if (markerRef.current && markerRef.current.setPosition) {
            markerRef.current.setPosition({ lat, lng });
            markerRef.current.setVisible(true);
        }
    };

    const loadGoogleMapsScript = () => {
        return new Promise((resolve, reject) => {
            if (window.google && window.google.maps && window.google.maps.places) {
                resolve(window.google);
                return;
            }

            const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
            if (existingScript) {
                existingScript.remove();
            }

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(window.google);
            script.onerror = (error) => {
                console.error("Google Maps script failed to load", error);
                reject(error);
            };
            document.head.appendChild(script);
        });
    };

    useEffect(() => {
        let isMounted = true;

        const initGoogleMaps = async () => {
            try {
                await loadGoogleMapsScript();
                if (isMounted) {
                    setGoogleMapsLoaded(true);
                    console.log("✅ Google Maps loaded successfully");
                }
            } catch (error) {
                console.error("❌ Failed to load Google Maps:", error);
                if (isMounted) {
                    alert("Failed to load maps. Please check your internet connection and refresh the page.");
                }
            }
        };

        initGoogleMaps();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (!showAddressPopup || !googleMapsLoaded) {
            return;
        }

        let isMounted = true;
        let retryCount = 0;
        const maxRetries = 10;

        const initializeMap = () => {
            if (!window.google || !window.google.maps || !window.google.maps.places) {
                if (retryCount < maxRetries) {
                    retryCount++;
                    console.log(`Waiting for Google Maps... retry ${retryCount}/${maxRetries}`);
                    setTimeout(initializeMap, 500);
                } else {
                    console.error("Google Maps failed to load after multiple retries");
                    alert("Maps failed to load. Please refresh the page.");
                }
                return;
            }

            const mapElement = document.getElementById("map");
            if (!mapElement) {
                console.error("Map element not found");
                return;
            }

            if (!isMounted) return;

            try {
                const defaultCenter = { lat: 20.5937, lng: 78.9629 };

                mapRef.current = new window.google.maps.Map(mapElement, {
                    center: defaultCenter,
                    zoom: 5,
                    mapTypeControl: false,
                    fullscreenControl: true,
                    streetViewControl: false,
                    zoomControl: true,
                });

                markerRef.current = new window.google.maps.Marker({
                    map: mapRef.current,
                    draggable: true,
                    visible: false,
                    animation: window.google.maps.Animation.DROP,
                });

                if (searchInputRef.current) {
                    const autocomplete = new window.google.maps.places.Autocomplete(searchInputRef.current, {
                        types: ["geocode"],
                        componentRestrictions: { country: "IN" }
                    });

                    autocomplete.addListener("place_changed", () => {
                        const place = autocomplete.getPlace();
                        if (place && place.geometry && place.geometry.location) {
                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            moveMap(lat, lng);

                            if (place.address_components) {
                                const { city, state, pincode } = extractAddressFields(place.address_components);
                                setAddressForm(prev => ({
                                    ...prev,
                                    city,
                                    state,
                                    pincode,
                                    latitude: lat,
                                    longitude: lng
                                }));
                            }
                        }
                    });
                }

                markerRef.current.addListener("dragend", (e) => {
                    if (isMounted) {
                        const lat = e.latLng.lat();
                        const lng = e.latLng.lng();
                        setLatitude(lat);
                        setLongitude(lng);
                        setAddressForm(prev => ({
                            ...prev,
                            latitude: lat,
                            longitude: lng
                        }));

                        const geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                            if (status === "OK" && results[0]) {
                                const { city, state, pincode } = extractAddressFields(results[0].address_components);
                                setAddressForm(prev => ({
                                    ...prev,
                                    city,
                                    state,
                                    pincode
                                }));
                            }
                        });
                    }
                });

                setMapInitialized(true);
                console.log("✅ Map initialized successfully");

            } catch (error) {
                console.error("Error initializing map:", error);
            }
        };

        setTimeout(initializeMap, 100);

        return () => {
            isMounted = false;
            setMapInitialized(false);
            if (markerRef.current) {
                markerRef.current.setMap(null);
                markerRef.current = null;
            }
            if (mapRef.current) {
                mapRef.current = null;
            }
        };
    }, [showAddressPopup, googleMapsLoaded]);

    const detectCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser");
            return;
        }

        setIsLocating(true);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                console.log("📍 Current location:", lat, lng);

                setLatitude(lat);
                setLongitude(lng);

                if (mapRef.current && mapRef.current.setCenter) {
                    mapRef.current.setCenter({ lat, lng });
                    mapRef.current.setZoom(16);
                }

                if (markerRef.current && markerRef.current.setPosition) {
                    markerRef.current.setPosition({ lat, lng });
                    markerRef.current.setVisible(true);
                }

                if (window.google && window.google.maps) {
                    const geocoder = new window.google.maps.Geocoder();
                    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                        if (status === "OK" && results[0]) {
                            const address = results[0].formatted_address;
                            const { city, state, pincode } = extractAddressFields(results[0].address_components);

                            setAddressForm(prev => ({
                                ...prev,
                                city,
                                state,
                                pincode,
                                latitude: lat,
                                longitude: lng
                            }));

                            if (searchInputRef.current) {
                                searchInputRef.current.value = address;
                            }

                            console.log("📍 Address found:", address);
                        } else {
                            setAddressForm(prev => ({
                                ...prev,
                                latitude: lat,
                                longitude: lng
                            }));
                        }
                        setIsLocating(false);
                    });
                } else {
                    setIsLocating(false);
                }
            },
            (error) => {
                console.error("Geolocation error:", error);
                let errorMessage = "Unable to fetch your location. ";
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMessage += "Please allow location access.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMessage += "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        errorMessage += "Location request timed out.";
                        break;
                    default:
                        errorMessage += "Please try again.";
                }
                alert(errorMessage);
                setIsLocating(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    const submitNewAddress = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!addressForm.latitude || !addressForm.longitude) {
            alert("Please select location on map or use current location");
            return;
        }

        if (!addressForm.category) {
            alert("Please select address category (Home/Office/Other)");
            return;
        }

        const addressParts = [
            addressForm.doorNumber,
            addressForm.addressLine,
            addressForm.landMark,
            addressForm.city,
            addressForm.state
        ].filter(Boolean);

        const addressString = addressParts.join(", ");

        const payload = {
            id: 0,
            userId: Number(userId),
            doorNumber: addressForm.doorNumber,
            addressLine: addressForm.addressLine,
            landMark: addressForm.landMark,
            city: addressForm.city,
            state: addressForm.state,
            pincode: Number(addressForm.pincode),
            name: addressForm.name,
            phoneNumber: addressForm.phoneNumber,
            latitude: Number(addressForm.latitude),
            longitude: Number(addressForm.longitude),
            address: addressString,
            category: addressForm.category
        };

        try {
            const response = await axios.post("https://backend.maamaas.com/subscription/api/user/location/add", payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
            });
            toast.success("Address saved successfully");
            await fetchAddresses();
            setShowAddAddressForm(false);
            setShowAddressPopup(false);

            if (response.data && response.data.id) {
                const newAddress = {
                    id: response.data.id,
                    address: addressString,
                    addressLine: addressForm.addressLine,
                    name: addressForm.name,
                    phoneNumber: addressForm.phoneNumber,
                    latitude: addressForm.latitude,
                    longitude: addressForm.longitude,
                    category: addressForm.category
                };
                setSelectedAddressObj(newAddress);
                localStorage.setItem("lastDeliveryAddress", JSON.stringify(newAddress));
                await confirmAddress(newAddress);
            }

            setAddressForm({
                doorNumber: "", addressLine: "", landMark: "", city: "", state: "", pincode: "", name: "", phoneNumber: "", latitude: null, longitude: null, category: "Home"
            });
        } catch (error) {
            console.error("Failed to add address", error);
            toast.error("Failed to save address");
        }
    };

    const handleSavedAddressClick = async (addr) => {
        setSelectedAddressObj(addr);
        setAddress(addr.address || addr.addressLine || "");
        localStorage.setItem("lastDeliveryAddress", JSON.stringify(addr));
        setShowAddressPopup(false);
        await confirmAddress(addr);
    };

    const confirmAddress = async (addr) => {
        try {
            const token = localStorage.getItem("authToken");
            const cartId = localStorage.getItem("cartId");
            const addressId = addr?.id;

            if (!cartId) {
                alert("Cart not found. Please add items to cart.");
                return;
            }
            if (!addressId) {
                alert("Please select a saved address");
                return;
            }

            await axios.put(
                `https://backend.maamaas.com/food/api/cart/delivery/${cartId}/address/${addressId}`,
                null,
                { headers: { Authorization: `Bearer ${token}`, Accept: "*/*" } }
            );

            await fetchCartDetails();
            setIsAddressValidForDelivery(true);
            toast.success("Delivery address selected! You can now proceed to checkout.");
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.response?.data || error.message;
            console.error("Failed to assign address:", errorMsg);
            toast.error("Failed to assign address");
            setIsAddressValidForDelivery(false);
        }
    };

    // ==================== FETCH AND SHOW INVOICE IN CART SECTION ====================
    const fetchAndShowInvoiceInCart = async (orderId) => {
        try {
            const { token } = getAuthVars();
            if (!token) {
                toast.error("Authentication required");
                return;
            }

            const orderResponse = await axios.get(
                `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (orderResponse.status === 200) {
                const orderData = orderResponse.data;
                setCompletedOrderData(orderData);
                toast.success("Order placed successfully! Invoice ready.");
            } else {
                toast.error("Could not fetch order details");
            }
        } catch (error) {
            console.error("Failed to fetch order:", error);
            toast.error("Could not load order details");
        }
    };

    // Reset after order completion
    const resetAfterOrder = () => {
        setScheduledOrderDetails(null);
        setScheduleDate("");
        setScheduleTime("");
        setShowPaymentOptions(false);
        setSelectedPaymentMethod(null);
        setSelectedwalletTypes(null);
        setOrderId(null);
        setCompletedOrderData(null);
        setCartItems([]);
        setQuantities({});
        setGrandTotal(0);
        setSubTotal(0);
        localStorage.removeItem("cartId");
        fetchCartDetails();
        fetchWalletData();
        if (isMobile) setIsCartPanelOpen(false);
    };

    // ==================== RAZORPAY LOADER ====================
    const loadRazorpayScript = () => new Promise(resolve => {
        if (window.Razorpay) { resolve(true); return; }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });

    // ==================== SCHEDULE ORDER FUNCTIONS ====================
    const openScheduleModal = () => {
        setIsScheduleModalOpen(true);
    };

    const handleScheduleConfirm = () => {
        if (!scheduleDate || !scheduleTime) {
            toast.error("Please select both date and time");
            return;
        }

        const scheduleDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
        const now = new Date();
        const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

        if (scheduleDateTime < twoHoursLater) {
            toast.error("Schedule time must be at least 2 hours from now");
            return;
        }

        setScheduledOrderDetails({
            date: scheduleDate,
            time: scheduleTime,
            isScheduled: true
        });

        setIsScheduleModalOpen(false);
        setShowPaymentOptions(true);
        setSelectedPaymentMethod(null);
        setSelectedwalletTypes(null);

        toast.success(`Order scheduled for ${scheduleDate} at ${scheduleTime}`);
    };

    // ==================== PAYMENT HANDLERS ====================
    const handleCashPayment = async (userId, token, cartId) => {
        try {
            let response;

            if (scheduledOrderDetails?.isScheduled) {
                const [hour, minute] = scheduledOrderDetails.time.split(":");

                const schedulePayload = {
                    cartId: cartId,
                    date: scheduledOrderDetails.date,
                    time: {
                        hour: parseInt(hour),
                        minute: parseInt(minute),
                        second: 0,
                        nano: 0
                    },
                    schedule: true,
                    paymentMethod: "Cash",
                    razorpayPaymentId: "N/A",
                    razorpayOrderId: "N/A",
                    walletTypes: [],
                    totalAmount: grandTotal,
                    userId: parseInt(userId)
                };

                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
                    schedulePayload,
                    {
                        params: { userId: parseInt(userId) },
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );
            } else {
                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                    null,
                    {
                        params: {
                            userId: parseInt(userId),
                            paymentMethod: "Cash",
                            amount: grandTotal
                        },
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );
            }

            const newOrderId = response.data?.orderId;

            if (newOrderId) {
                localStorage.setItem("orderId", newOrderId);
                setOrderId(newOrderId);
                setShowPaymentOptions(false);
                setScheduledOrderDetails(null);
                setScheduleDate("");
                setScheduleTime("");

                await fetchAndShowInvoiceInCart(newOrderId);

                if (scheduledOrderDetails?.isScheduled) {
                    toast.success(`✅ Order scheduled for ${scheduledOrderDetails.date} at ${scheduledOrderDetails.time} with Cash on Delivery!`);
                } else {
                    toast.success("✅ Order placed successfully!");
                }
            } else {
                throw new Error("No order ID received");
            }

        } catch (error) {
            console.error("Cash Payment Error:", error);
            toast.error(error.response?.data?.message || "Cash payment failed");
            setOrderPlacing(false);
        }
    };

    const handleWalletPayment = async (userId, token, cartId) => {
        try {
            if (!selectedwalletTypes) {
                toast.error("Please select a wallet type");
                setOrderPlacing(false);
                return;
            }

            const mappedwalletTypes = walletTypesMap[selectedwalletTypes];
            if (!mappedwalletTypes) {
                toast.error("Invalid wallet type selected");
                setOrderPlacing(false);
                return;
            }

            let availableAmount = 0;
            switch (mappedwalletTypes) {
                case "SELF_LOADED":
                    availableAmount = availableSelf;
                    break;
                case "COMPANY_LOADED":
                    availableAmount = availableCompany;
                    break;
                case "CASHBACK":
                    availableAmount = availableCashback;
                    break;
                default:
                    availableAmount = availableBalance;
            }

            if (availableAmount < grandTotal) {
                toast.error(`Insufficient ${selectedwalletTypes} balance. Available: ₹${availableAmount.toFixed(2)}, Required: ₹${grandTotal.toFixed(2)}`);
                setOrderPlacing(false);
                return;
            }

            let response;

            if (scheduledOrderDetails?.isScheduled) {
                const [hour, minute] = scheduledOrderDetails.time.split(":");

                const schedulePayload = {
                    cartId: cartId,
                    date: scheduledOrderDetails.date,
                    time: {
                        hour: parseInt(hour),
                        minute: parseInt(minute),
                        second: 0,
                        nano: 0
                    },
                    schedule: true,
                    paymentMethod: "Maamaas_Wallet",
                    razorpayPaymentId: "N/A",
                    razorpayOrderId: "N/A",
                    walletTypes: [mappedwalletTypes],
                    totalAmount: grandTotal,
                    userId: parseInt(userId)
                };

                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
                    schedulePayload,
                    {
                        params: { userId: parseInt(userId) },
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );
            } else {
                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                    null,
                    {
                        params: {
                            userId: parseInt(userId),
                            paymentMethod: "Maamaas_Wallet",
                            walletTypes: mappedwalletTypes,
                            amount: grandTotal,
                            razorpayPaymentId: "N/A",
                            razorpayOrderId: "N/A"
                        },
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json"
                        }
                    }
                );
            }

            const newOrderId = response.data?.orderId || response.data?.id;

            if (newOrderId) {
                localStorage.setItem("orderId", newOrderId);
                setOrderId(newOrderId);
                setShowPaymentOptions(false);
                setScheduledOrderDetails(null);
                setScheduleDate("");
                setScheduleTime("");
                await fetchWalletData();

                await fetchAndShowInvoiceInCart(newOrderId);
                toast.success(`✅ Order placed successfully using ${selectedwalletTypes} wallet!`);
            } else {
                throw new Error("No order ID received from server");
            }

        } catch (error) {
            console.error("Wallet Payment Error:", error);
            toast.error(error.response?.data?.message || "Wallet payment failed");
            setOrderPlacing(false);
        }
    };

    const handleOnlinePayment = async (userId, token, cartId) => {
        try {
            setOrderPlacing(true);

            const amountInRupees = Number(grandTotal);
            const amountInPaise = Math.round(amountInRupees * 100);

            const isLoaded = await loadRazorpayScript();
            if (!isLoaded) throw new Error("Razorpay SDK failed to load");

            const orderRes = await axios.post(
                "https://backend.maamaas.com/food/api/payments/create-order/user",
                {
                    amount: amountInPaise,
                    currency: "INR",
                    receipt: `order_${Date.now()}`,
                    userId: parseInt(userId),
                    cartId: cartId,
                    isScheduled: scheduledOrderDetails?.isScheduled || false,
                    scheduleDate: scheduledOrderDetails?.date,
                    scheduleTime: scheduledOrderDetails?.time
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            const razorpayOrderId = orderRes.data?.id || orderRes.data?.orderId;
            if (!razorpayOrderId) throw new Error("Failed to create Razorpay order");

            const options = {
                key: "rzp_live_RU5whSMu9rPV7s",
                amount: amountInPaise,
                currency: "INR",
                name: "Maamaas Foods",
                description: `Pay ₹${amountInRupees} for Cart ${cartId}`,
                order_id: razorpayOrderId,
                handler: async function (response) {
                    try {
                        const {
                            razorpay_payment_id: paymentId,
                            razorpay_order_id: rzpOrderId,
                            razorpay_signature: signature
                        } = response;

                        await axios.post(
                            "https://backend.maamaas.com/food/api/payments/capture",
                            {
                                paymentId,
                                orderId: rzpOrderId,
                                amount: amountInPaise,
                                signature
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json"
                                }
                            }
                        );

                        let orderResponse;

                        if (scheduledOrderDetails?.isScheduled) {
                            const [hour, minute] = scheduledOrderDetails.time.split(":");

                            const scheduleData = {
                                cartId: cartId,
                                date: scheduledOrderDetails.date,
                                time: {
                                    hour: parseInt(hour),
                                    minute: parseInt(minute),
                                    second: 0,
                                    nano: 0
                                },
                                schedule: true,
                                paymentMethod: "Online_Payment",
                                razorpayPaymentId: paymentId,
                                razorpayOrderId: rzpOrderId,
                                walletTypes: [],
                                totalAmount: amountInRupees,
                                userId: parseInt(userId)
                            };

                            orderResponse = await axios.post(
                                `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
                                scheduleData,
                                {
                                    params: { userId: parseInt(userId) },
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json"
                                    }
                                }
                            );

                        } else {
                            orderResponse = await axios.post(
                                `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                                null,
                                {
                                    params: {
                                        userId: parseInt(userId),
                                        paymentMethod: "Online_Payment",
                                        amount: amountInRupees,
                                        razorpayPaymentId: paymentId,
                                        razorpayOrderId: rzpOrderId
                                    },
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json"
                                    }
                                }
                            );
                        }

                        const newOrderId = orderResponse.data?.orderId;

                        if (newOrderId) {
                            localStorage.setItem("orderId", newOrderId);
                            setOrderId(newOrderId);
                            setShowPaymentOptions(false);
                            setScheduledOrderDetails(null);
                            setScheduleDate("");
                            setScheduleTime("");

                            await fetchAndShowInvoiceInCart(newOrderId);
                            toast.success(`✅ Payment successful! Paid ₹${amountInRupees.toFixed(2)}`);
                        }

                    } catch (err) {
                        console.error("Payment handler error:", err);
                        toast.error("Payment successful but order creation failed.");
                    } finally {
                        setOrderPlacing(false);
                    }
                },
                modal: {
                    ondismiss: () => {
                        setOrderPlacing(false);
                        toast.info("Payment cancelled");
                    }
                },
                prefill: {
                    name: userProfile?.name || "",
                    email: userProfile?.email || "",
                    contact: userProfile?.phoneNumber || ""
                },
                theme: { color: "#ee6521" }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error("Payment Error:", err);
            toast.error("Payment failed: " + err.message);
            setOrderPlacing(false);
        }
    };

    // ==================== PLACE ORDER ====================
    const handlePlaceOrder = async () => {
        if (orderType === 'DELIVERY' && !selectedAddressObj) {
            toast.error("Please select a delivery address");
            setShowAddressPopup(true);
            setOrderPlacing(false);
            return;
        }

        if (!selectedPaymentMethod) {
            toast.error("Please select a payment method");
            return;
        }
        if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedwalletTypes) {
            toast.error("Please select a wallet type");
            return;
        }

        const { userId, token, cartId } = getAuthVars();
        if (!userId || !token) {
            toast.error("User not logged in. Please login again.");
            return;
        }
        if (!cartId) {
            toast.error("Cart is empty. Please add items to cart.");
            return;
        }
        if (cartItems.length === 0) {
            toast.error("Your cart is empty.");
            return;
        }

        setOrderPlacing(true);
        try {
            if (selectedPaymentMethod === "Online_Payment") {
                await handleOnlinePayment(userId, token, cartId);
            } else if (selectedPaymentMethod === "Maamaas_Wallet") {
                await handleWalletPayment(userId, token, cartId);
            } else if (selectedPaymentMethod === "Cash") {
                await handleCashPayment(userId, token, cartId);
            }
        } catch (error) {
            console.error("Order placement error:", error);
            toast.error(error.response?.data?.message || error.message || "Failed to place order.");
            setOrderPlacing(false);
        }
    };

    // ==================== INITIAL DATA FETCH ====================
useEffect(() => {
    const fetchData = async () => {
        const { token, userId } = getAuthVars();
        const vendorId = localStorage.getItem("vendorId");

        if (!vendorId || !token || !userId) {
            setError(new Error("vendorId, userId or authToken missing"));
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const dishData = Array.isArray(data) ? data : data.data || [];
            
            // Store ALL dishes without any filtering
            setAllDishes(dishData);
            
            // Initially show only enabled dishes
            const enabledDishes = dishData.filter(item => item?.menuStatus === "Enable");
            setDishes(enabledDishes);
            setFilteredDishes(enabledDishes);

        } catch (error) {
            console.error(error);
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    fetchData();
    fetchCartDetails();
    fetchWalletData();
}, [cartRefresh]); // Remove parentId from dependencies

// FIX 2: Combined filter useEffect (replaces your search filter useEffect)
useEffect(() => {
    if (!Array.isArray(allDishes)) return;

    let filtered = [...allDishes];

    // Step 1: Filter by parentId (category)
    if (parentId !== null && parentId !== undefined) {
        filtered = filtered.filter(
            item => Number(item.parentId) === Number(parentId)
        );
    }

    // Step 2: Filter by search term
    const searchValue = searchTerm?.toLowerCase().trim() || "";
    if (searchValue !== "") {
        filtered = filtered.filter(
            item =>
                item?.dishName &&
                item.dishName.toLowerCase().includes(searchValue)
        );
    }

    // Step 3: Only Enabled Items
    filtered = filtered.filter(item => item?.menuStatus === "Enable");

    setFilteredDishes(filtered);
    setDishes(filtered); // Keep dishes in sync

}, [parentId, searchTerm, allDishes]);


    


    useEffect(() => {
        fetchWalletData();
    }, []);

    useEffect(() => {
        if (showPaymentOptions) {
            fetchWalletData();
        }
    }, [showPaymentOptions]);

    const getTotalItems = () => cartItems.reduce((t, i) => t + (quantities[i.itemId] || i.quantity || 1), 0);
    const cartItemsCount = getTotalItems();

    if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
    if (error) return <div style={{ padding: '40px', textAlign: 'center', color: 'red' }}>Error: {error.message}</div>;

    // ==================== RENDER ====================
    return (
        <div style={{ marginTop: '90px', display: 'flex', gap: '20px' }} className='menuiteams-data'>

            {/* ===== MAIN CONTENT ===== */}
            <div style={{ flex: 1, minWidth: 0 }}>
                {/* Filter Bar */}
                <div className="menu-filter-wrapper">
                    <div className="menu-filter-bar">
                        <div className="menu-filter-left">
                            <div className="menu-filter-label">Filters</div>
                            {(searchTerm || isVegSelected || isNonVegSelected || selectedCategory !== "ALL" || discountFilter !== "Offers" || couponFilter !== "Coupons") && (
                                <button className="menu-clear-btn" onClick={() => {
                                    setSearchTerm(""); setIsVegSelected(false); setIsNonVegSelected(false);
                                    setSelectedCategory("ALL"); setDiscountFilter("Offers"); setCouponFilter("Coupons");
                                }}>✕ Clear</button>
                            )}
                        </div>
                        <div className="menu-filter-right">
                            <select className="menu-select" value={discountFilter} onChange={e => setDiscountFilter(e.target.value)}>
                                <option value="Offers">Offers</option>
                                <option value="10% OFF">10% OFF</option>
                                <option value="20% OFF">20% OFF</option>
                                <option value="30% OFF">30% OFF</option>
                                <option value="50% OFF">50% OFF</option>
                            </select>
                            <select className="menu-select" value={couponFilter} onChange={e => setCouponFilter(e.target.value)}>
                                <option value="Coupons">Coupons</option>
                                <option value="FREEDEL">FREEDEL</option>
                                <option value="SAVE20">SAVE20</option>
                                <option value="WELCOME50">WELCOME50</option>
                            </select>
                            <input type="text" placeholder="Search dish..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="menu-search" />
                            <div className={`menu-chip veg ${isVegSelected ? "active" : ""}`} onClick={() => { setIsVegSelected(!isVegSelected); setIsNonVegSelected(false); }}>🌱 Veg</div>
                            <div className={`menu-chip nonveg ${isNonVegSelected ? "active" : ""}`} onClick={() => { setIsNonVegSelected(!isNonVegSelected); setIsVegSelected(false); }}>🍗 Non-Veg</div>
                        </div>
                    </div>
                </div>

                {/* Categories */}
                <div className="category-section-vikash" style={{ marginBottom: '20px', padding: '0 16px' }}>
    <h3 className="category-title-vikash" style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', color: '#333' }}>
        Explore Categories
    </h3>

    {categoriesLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
                width: '20px',
                height: '20px',
                border: '2px solid #f3f3f3',
                borderTop: '2px solid #ee6521',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
            }}></div>
            <span>Loading categories...</span>
        </div>
    ) : (
        <div style={{
            display: 'flex',
            gap: '12px',
            overflowX: 'auto',
            paddingBottom: '8px',
            scrollbarWidth: "none"
        }}>

            {[{
                categoryName: 'ALL',
                dishId: null,
                image: 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png'
            }, ...categories].map(cat => (

                <div
                    key={cat.categoryName}
                    onClick={() => handleCategoryClick(cat)}  // ✅ FIXED
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: '60px',
                        cursor: 'pointer',
                        padding: '5px'
                    }}
                >

                    <div style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        marginBottom: '6px',
                        border: selectedCategory === cat.categoryName
                            ? '2px solid #ee6521'
                            : '2px solid #ddd'
                    }}>
                        <img
                            src={cat.image}
                            alt={cat.categoryName}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={e => {
                                e.target.src = "https://cdn-icons-png.flaticon.com/512/1046/1046784.png";
                            }}
                        />
                    </div>

                    <p style={{
                        fontSize: '12px',
                        fontWeight: selectedCategory === cat.categoryName ? '600' : '400',
                        color: selectedCategory === cat.categoryName ? '#ee6521' : '#333',
                        margin: 0,
                        textAlign: 'center'
                    }}>
                        {cat.categoryName === 'ALL'
                            ? 'All'
                            : (cat.categoryName?.length > 12
                                ? cat.categoryName.slice(0, 10) + '...'
                                : cat.categoryName)}
                    </p>

                </div>
            ))}
        </div>
    )}
</div>

                {/* Dishes Grid */}
                <div className="offers-containers" style={{ padding: '0 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px' }}>
                    {filteredDishes.map(item => {
                        const isOutOfStock = Number(item.balanceQuantity) <= 0;
                        const cartItem = cartItems.find(ci => ci.dishId === item.dishId);
                        const qty = cartItem ? (quantities[cartItem.itemId] || cartItem.quantity || 0) : 0;

                        return (
                            <div key={item.dishId} className="offers-cards"
                                style={{ position: "relative", borderRadius: "16px", overflow: "hidden", transition: "transform 0.3s ease, box-shadow 0.3s ease", cursor: "pointer", backgroundColor: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", scrollbarWidth: "none" }}
                                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.12)"; }}
                                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}>

                                {/* Favorite Button */}
                                <div style={{ position: "absolute", top: "12px", right: "12px", zIndex: 15, backgroundColor: "rgba(255,255,255,0.9)", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: isOutOfStock ? "not-allowed" : "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
                                    onClick={e => { e.stopPropagation(); if (!isOutOfStock) handleAddToFavorites(item.dishId); }}>
                                    <i className="fa-regular fa-heart" style={{ fontSize: "18px", color: favorites.includes(item.dishId) ? "#dc2626" : "#ee6521" }} />
                                </div>

                                {/* Image */}
                                <div style={{ position: "relative", pointerEvents: isOutOfStock ? "none" : "auto" }}>
                                    <img src={item.dishImage || "default-image.jpg"} alt="Dish"
                                        style={{ width: "100%", height: "180px", objectFit: "cover" }} />
                                    {isOutOfStock && (
                                        <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "700" }}>
                                            OUT OF STOCK
                                        </div>
                                    )}
                                </div>

                                {/* Card Body */}
                                <div style={{ padding: "14px" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                                        <h5 style={{ fontSize: "16px", fontWeight: "700", color: "#ee6521", margin: 0, flex: 1 }}>{item.dishName}</h5>
                                        <div style={{ marginLeft: "8px", width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#ee6521", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer" }}
                                            onClick={e => { e.stopPropagation(); handleToggleTooltip(item.dishId, item.description); }}>i</div>
                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "18px", height: "18px", border: `2px solid ${item.tag === "Veg" ? "#2e7d32" : "#d32f2f"}`, borderRadius: "2px", marginLeft: "8px", position: "relative" }}>
                                            <span style={{ width: "8px", height: "8px", backgroundColor: item.tag === "Veg" ? "#2e7d32" : "#d32f2f", borderRadius: "50%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
                                        </span>
                                    </div>

                                    {/* Tooltip */}
                                    {activeTooltip === item.dishId && (
                                        <div style={{ background: '#fff8f5', border: '1px solid #ee6521', borderRadius: '8px', padding: '8px', fontSize: '12px', color: '#555', marginBottom: '8px' }}>
                                            {description || 'No description available.'}
                                        </div>
                                    )}

                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                                        {item.effectivePrice !== undefined && item.effectivePrice > 0 ? (
                                            <>
                                                <span style={{ fontSize: "14px", color: "#999", textDecoration: "line-through" }}>₹{item.price}</span>
                                                <span style={{ fontSize: "20px", fontWeight: "bold", color: "#2e7d32" }}>₹{item.effectivePrice.toFixed(2)}</span>
                                            </>
                                        ) : (
                                            <span style={{ fontSize: "20px", fontWeight: "bold", color: "#2e7d32" }}>₹{item.price}</span>
                                        )}
                                    </div>

                                    {isOutOfStock ? (
                                        <button onClick={() => { const { userId } = getAuthVars(); if (!userId) { setShowLogin(true); return; } addToCart(item, 1, true); }}
                                            style={{ background: "#ff9800", color: "#fff", fontSize: "13px", fontWeight: "600", border: "none", width: "100%", padding: "10px", borderRadius: "25px", cursor: "pointer" }}>
                                            Schedule Now
                                        </button>
                                    ) : qty > 0 ? (
                                        <div style={{ borderRadius: "50px", backgroundColor: "#ee6521", width: "100%", height: "40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <button onClick={() => decreaseQuantity(item)} style={{ color: "#fff", fontSize: "22px", fontWeight: "bold", width: "40px", height: "100%", background: "transparent", border: "none", cursor: "pointer" }}>-</button>
                                            <span style={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}>{qty}</span>
                                            <button onClick={() => increaseQuantity(item.dishId, item)} style={{ color: "#fff", fontSize: "22px", fontWeight: "bold", width: "40px", height: "100%", background: "transparent", border: "none", cursor: "pointer" }}>+</button>
                                        </div>
                                    ) : (
                                        <button onClick={() => { const { userId } = getAuthVars(); if (!userId) { setShowLogin(true); return; } addToCart(item, 1); }}
                                            style={{ background: "#ee6521", color: "#fff", width: "100%", padding: "10px", border: "none", borderRadius: "25px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                                            Add To Cart
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* ===== FLOATING CART BUTTON FOR MOBILE ===== */}
            {isMobile && cartItemsCount > 0 && !completedOrderData && (
                <button
                    onClick={() => setIsCartPanelOpen(true)}
                    style={{
                        position: 'fixed',
                        bottom: '80px',
                        right: '20px',
                        background: '#ee6521',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50px',
                        padding: '14px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        zIndex: 100,
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }}
                >
                    <ShoppingCart />
                    <span>{cartItemsCount}</span>
                </button>
            )}

            {/* ===== MOBILE CART DRAWER (SLIDES FROM RIGHT) ===== */}
            {isMobile && isCartPanelOpen && (
                <>
                    {/* Overlay */}
                    <div
                        onClick={() => setIsCartPanelOpen(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            zIndex: 1000,
                            animation: 'fadeIn 0.3s ease'
                        }}
                    />

                    {/* Drawer */}
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: '85%',
                            maxWidth: '352px',
                            backgroundColor: '#fafafa',
                            zIndex: 1001,
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
                            animation: 'slideInRight 0.3s ease',
                            overflow: 'hidden',
                            scrollbarWidth: "none"
                        }}
                    >
                        {/* Header */}
                        <div style={{
                            padding: '16px 20px',
                            backgroundColor: '#ee6521',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexShrink: 0
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {completedOrderData ? (
                                    <>
                                        <span style={{ fontSize: '22px' }}>🧾</span>
                                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Order Invoice</span>
                                    </>
                                ) : (
                                    <>
                                        <ShoppingCart style={{ fontSize: '22px' }} />
                                        <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Your Cart</span>
                                        <span style={{ background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '20px', fontSize: '12px' }}>
                                            {cartItemsCount} items
                                        </span>
                                    </>
                                )}
                            </div>
                            {!completedOrderData && cartItems.length > 0 && (
                                <button
                                    onClick={handleClearCart}
                                    style={{
                                        background: 'rgba(255,255,255,0.2)',
                                        border: 'none',
                                        color: '#fff',
                                        cursor: 'pointer',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px'
                                    }}
                                >
                                    <DeleteOutline style={{ fontSize: '16px' }} /> Clear
                                </button>
                            )}
                            <button
                                onClick={() => setIsCartPanelOpen(false)}
                                style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Close style={{ fontSize: '20px' }} />
                            </button>
                        </div>

                        {/* Scrollable Content */}
                        <div style={{ flex: 1, overflowY: 'auto', padding: '16px', scrollbarWidth: "none" }}>
                            {completedOrderData ? (
                                <InvoiceComponent
                                    orderData={completedOrderData}
                                    onOrderAgain={() => {
                                        resetAfterOrder();
                                        setIsCartPanelOpen(false);
                                    }}
                                />
                            ) : (
                                <>
                                    {cartItems.length === 0 ? (
                                        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#bbb' }}>
                                            <ShoppingCart style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.4 }} />
                                            <p style={{ margin: 0, fontWeight: '500' }}>Your cart is empty</p>
                                            <p style={{ margin: '8px 0 0', fontSize: '13px' }}>Add items from the menu</p>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Cart Items List */}
                                            {cartItems.map(item => {
                                                const qty = quantities[item.itemId] || item.quantity || 1;
                                                const price = parseFloat(item.effectivePrice) || parseFloat(item.price) || 0;
                                                return (
                                                    <div key={item.itemId} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                        <img src={item.dishImage || 'https://via.placeholder.com/50'} alt={item.dishName}
                                                            style={{ width: '50px', height: '50px', borderRadius: '10px', objectFit: 'cover', flexShrink: 0 }} />
                                                        <div style={{ flex: 1, minWidth: 0 }}>
                                                            <div style={{ fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', scrollbarWidth: "none" }}>{item.dishName}</div>
                                                            <div style={{ color: '#2e7d32', fontSize: '13px', fontWeight: 'bold' }}>₹{price.toFixed(2)}</div>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#f5f5f5', borderRadius: '25px', padding: '3px 8px', flexShrink: 0 }}>
                                                            <button onClick={() => decrementQuantity(item)}
                                                                style={{ width: '28px', height: '28px', borderRadius: '50%', border: 'none', background: '#fff', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                                                                {qty === 1 ? '🗑' : '-'}
                                                            </button>
                                                            <span style={{ minWidth: '25px', textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>{qty}</span>
                                                            <button onClick={() => incrementQuantity(item)}
                                                                style={{ width: '28px', height: '28px', borderRadius: '50%', border: 'none', background: '#fff', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                                                                +
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            {/* Price Summary */}
                                            <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '16px' }}>
                                                <div className="price-row" style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '14px', alignItems: 'center' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        GST
                                                        <BsInfoCircleFill onClick={handleShowGST} style={{ fontSize: '14px', color: '#ee6521', cursor: 'pointer' }} />
                                                    </span>
                                                    <span>₹{gstTotal.toFixed(2)}</span>
                                                </div>

                                                {[
                                                    { label: 'Sub Total', value: subTotal },
                                                    platformCharges > 0 && { label: 'Platform Charges', value: platformCharges },
                                                    packingCharges > 0 && { label: 'Packing Charges', value: packingCharges },
                                                    deliveryCharges > 0 && { label: 'Delivery Charges', value: deliveryCharges },
                                                    discountAmount > 0 && { label: 'Discount', value: discountAmount, green: true },
                                                ].filter(Boolean).map((row, i) => (
                                                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '14px', color: row.green ? '#22c55e' : '#555' }}>
                                                        <span>{row.label}</span>
                                                        <span>{row.green ? '-' : ''}₹{Math.abs(row.value).toFixed(2)}</span>
                                                    </div>
                                                ))}

                                                {/* Apply Coupon Button */}
                                                <div style={{ margin: '16px 0' }}>
                                                    {!appliedCoupon ? (
                                                        <button
                                                            onClick={() => navigate("/Notifications")}
                                                            style={{
                                                                width: '100%',
                                                                padding: '12px',
                                                                backgroundColor: '#ee6521',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '10px',
                                                                cursor: 'pointer',
                                                                fontWeight: '600',
                                                                fontSize: '14px'
                                                            }}
                                                        >
                                                            Apply Coupon
                                                        </button>
                                                    ) : (
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', backgroundColor: '#e8f5e9', borderRadius: '10px' }}>
                                                            <span style={{ color: '#22c55e', fontWeight: '500' }}>🎉 Coupon Applied! Saved ₹{discountAmount.toFixed(2)}</span>
                                                            <button onClick={handleRemoveCoupon} style={{ padding: '6px 14px', backgroundColor: '#dc2626', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>Remove</button>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Grand Total */}
                                                <div style={{ borderTop: '2px solid #ddd', margin: '16px 0', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 'bold' }}>
                                                    <span>Grand Total</span>
                                                    <span style={{ color: '#ee6521' }}>₹{grandTotal.toFixed(2)}</span>
                                                </div>

                                                {/* Order Type */}
                                                <select value={orderType} onChange={(e) => { setOrderType(e.target.value); if (e.target.value === 'DELIVERY' && !selectedAddressObj) setShowAddressPopup(true); }}
                                                    style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #ddd', marginBottom: '12px', fontSize: '14px' }}>
                                                    <option value="DELIVERY">🚚 Delivery</option>
                                                    <option value="DINE_IN">🍽️ Dine In</option>
                                                    <option value="TAKEAWAY">📦 Takeaway</option>
                                                </select>

                                                {/* Address Display */}
                                                {orderType === 'DELIVERY' && (
                                                    <div onClick={() => setShowAddressPopup(true)} style={{ padding: '14px', backgroundColor: selectedAddressObj ? '#f0fdf4' : '#fff3e0', borderRadius: '10px', marginBottom: '12px', cursor: 'pointer', border: `1px solid ${selectedAddressObj ? '#22c55e' : '#ff9800'}` }}>
                                                        {selectedAddressObj ? (
                                                            <>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                                                    <span>✅</span>
                                                                    <span style={{ fontWeight: 'bold', color: '#22c55e' }}>Delivery Address Selected</span>
                                                                </div>
                                                                <div style={{ fontSize: '13px' }}>📍 {selectedAddressObj.address || selectedAddressObj.addressLine}</div>
                                                                {selectedAddressObj.name && <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>{selectedAddressObj.name} | {selectedAddressObj.phoneNumber}</div>}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span>⚠️</span>
                                                                    <span style={{ fontWeight: 'bold', color: '#ff9800' }}>Add Delivery Address</span>
                                                                </div>
                                                                <div style={{ fontSize: '12px', marginTop: '4px' }}>Click to add delivery address</div>
                                                            </>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Action Buttons */}
                                                <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                                                    <button onClick={openScheduleModal} disabled={showPaymentOptions}
                                                        style={{ flex: 1, padding: '12px', backgroundColor: '#fff', color: '#ee6521', border: '2px solid #ee6521', borderRadius: '30px', fontWeight: 'bold', cursor: showPaymentOptions ? 'not-allowed' : 'pointer', opacity: showPaymentOptions ? 0.6 : 1 }}>
                                                        📅 Schedule
                                                    </button>
                                                    {!showPaymentOptions ? (
                                                        <button onClick={() => { if (orderType === 'DELIVERY' && !selectedAddressObj) { toast.error("Please add delivery address"); setShowAddressPopup(true); return; } setShowPaymentOptions(true); }}
                                                            style={{ flex: 1, padding: '12px', backgroundColor: '#ee6521', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer' }}>
                                                            Checkout
                                                        </button>
                                                    ) : (
                                                        <button onClick={() => setShowPaymentOptions(false)} style={{ flex: 1, padding: '12px', backgroundColor: '#6b7280', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer' }}>
                                                            Back
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Payment Options */}
                                                {showPaymentOptions && (
                                                    <div style={{ marginTop: '16px' }}>
                                                        <div style={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '15px' }}>Select Payment Method</div>
                                                        {[
                                                            // { id: 'Cash', icon: '💵', label: 'Cash on Delivery' },
                                                            { id: 'Maamaas_Wallet', icon: '👛', label: `Wallet (₹${availableBalance.toFixed(2)})` },
                                                            { id: 'Online_Payment', icon: '💳', label: 'Online Payment' },
                                                        ].map(pm => (
                                                            <div key={pm.id} onClick={() => { setSelectedPaymentMethod(pm.id); if (pm.id !== 'Maamaas_Wallet') setSelectedwalletTypes(null); }}
                                                                style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px', borderRadius: '12px', marginBottom: '10px', cursor: 'pointer', border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#e5e7eb'}`, backgroundColor: selectedPaymentMethod === pm.id ? '#fff8f5' : '#fff' }}>
                                                                <span style={{ fontSize: '26px' }}>{pm.icon}</span>
                                                                <span style={{ flex: 1, fontSize: '14px', fontWeight: selectedPaymentMethod === pm.id ? '600' : '400' }}>{pm.label}</span>
                                                                <div style={{ width: '22px', height: '22px', borderRadius: '50%', border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#ccc'}`, backgroundColor: selectedPaymentMethod === pm.id ? '#ee6521' : '#fff' }}></div>
                                                            </div>
                                                        ))}

                                                        {selectedPaymentMethod === 'Maamaas_Wallet' && (
                                                            <div style={{ marginTop: '12px', padding: '14px', backgroundColor: '#f9f9f9', borderRadius: '12px' }}>
                                                                <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Select Wallet Type:</div>
                                                                {[
                                                                    { key: 'Self Loaded', label: 'Self Loaded', bal: availableSelf },
                                                                    { key: 'Company Loaded', label: 'Company Loaded', bal: availableCompany },
                                                                    { key: 'Cashback', label: 'Cashback', bal: availableCashback },
                                                                ].map(wt => (
                                                                    <div key={wt.key} onClick={() => setSelectedwalletTypes(wt.key)}
                                                                        style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', borderRadius: '10px', marginBottom: '8px', cursor: 'pointer', backgroundColor: selectedwalletTypes === wt.key ? '#fff8f5' : '#fff', border: `1px solid ${selectedwalletTypes === wt.key ? '#ee6521' : '#ddd'}` }}>
                                                                        <span>{wt.label}</span>
                                                                        <span style={{ color: '#22c55e', fontWeight: 'bold' }}>₹{wt.bal.toFixed(2)}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        <button onClick={handlePlaceOrder} disabled={orderPlacing || !selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)}
                                                            style={{ width: '100%', padding: '14px', marginTop: '16px', backgroundColor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? '#ee6521' : '#ccc', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', fontSize: '15px', cursor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? 'pointer' : 'not-allowed' }}>
                                                            {orderPlacing ? '⏳ Placing Order...' : '🛒 Place Order'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {/* ===== DESKTOP CART SIDEBAR ===== */}
            {!isMobile && (
                <div style={{ width: '352px', backgroundColor: '#fafafa', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', position: 'sticky', top: '90px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', scrollbarWidth: "none" }}>
                    {/* Header */}
                    <div style={{ padding: '16px 20px', backgroundColor: '#ee6521', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {completedOrderData ? (
                                <>
                                    <span style={{ fontSize: '22px' }}>🧾</span>
                                    <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Order Invoice</span>
                                </>
                            ) : (
                                <>
                                    <ShoppingCart style={{ fontSize: '22px' }} />
                                    <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Your Cart</span>
                                    <span style={{ background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '20px', fontSize: '12px' }}>
                                        {cartItemsCount} items
                                    </span>
                                </>
                            )}
                        </div>
                        {!completedOrderData && cartItems.length > 0 && (
                            <button onClick={handleClearCart} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', cursor: 'pointer', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <DeleteOutline style={{ fontSize: '16px' }} /> Clear
                            </button>
                        )}
                    </div>

                    {/* Scrollable Content */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '16px', scrollbarWidth: "none" }}>
                        {completedOrderData ? (
                            <InvoiceComponent
                                orderData={completedOrderData}
                                onOrderAgain={resetAfterOrder}
                            />
                        ) : (
                            <>
                                {cartItems.length === 0 ? (
                                    <div style={{ textAlign: 'center', padding: '60px 20px', color: '#bbb' }}>
                                        <ShoppingCart style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.4 }} />
                                        <p style={{ margin: 0, fontWeight: '500' }}>Your cart is empty</p>
                                        <p style={{ margin: '8px 0 0', fontSize: '13px' }}>Add items from the menu</p>
                                    </div>
                                ) : (
                                    <>
                                        {/* Cart Items List */}
                                        {cartItems.map(item => {
                                            const qty = quantities[item.itemId] || item.quantity || 1;
                                            const price = parseFloat(item.effectivePrice) || parseFloat(item.price) || 0;
                                            return (
                                                <div key={item.itemId} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                    <img src={item.dishImage || 'https://via.placeholder.com/50'} alt={item.dishName}
                                                        style={{ width: '50px', height: '50px', borderRadius: '10px', objectFit: 'cover', flexShrink: 0 }} />
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', scrollbarWidth: "none" }}>{item.dishName}</div>
                                                        <div style={{ color: '#2e7d32', fontSize: '13px', fontWeight: 'bold' }}>₹{price.toFixed(2)}</div>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#f5f5f5', borderRadius: '25px', padding: '3px 8px', flexShrink: 0 }}>
                                                        <button onClick={() => decrementQuantity(item)}
                                                            style={{ width: '28px', height: '28px', borderRadius: '50%', border: 'none', background: '#fff', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                                                            {qty === 1 ? '🗑' : '-'}
                                                        </button>
                                                        <span style={{ minWidth: '25px', textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>{qty}</span>
                                                        <button onClick={() => incrementQuantity(item)}
                                                            style={{ width: '28px', height: '28px', borderRadius: '50%', border: 'none', background: '#fff', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        {/* Price Summary */}
                                        <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '16px' }}>
                                            <div className="price-row" style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '14px', alignItems: 'center' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    GST
                                                    <BsInfoCircleFill onClick={handleShowGST} style={{ fontSize: '14px', color: '#ee6521', cursor: 'pointer' }} />
                                                </span>
                                                <span>₹{gstTotal.toFixed(2)}</span>
                                            </div>

                                            {[
                                                { label: 'Sub Total', value: subTotal },
                                                platformCharges > 0 && { label: 'Platform Charges', value: platformCharges },
                                                packingCharges > 0 && { label: 'Packing Charges', value: packingCharges },
                                                deliveryCharges > 0 && { label: 'Delivery Charges', value: deliveryCharges },
                                                discountAmount > 0 && { label: 'Discount', value: discountAmount, green: true },
                                            ].filter(Boolean).map((row, i) => (
                                                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '14px', color: row.green ? '#22c55e' : '#555' }}>
                                                    <span>{row.label}</span>
                                                    <span>{row.green ? '-' : ''}₹{Math.abs(row.value).toFixed(2)}</span>
                                                </div>
                                            ))}

                                            {/* Apply Coupon Button */}
                                            <div style={{ margin: '16px 0' }}>
                                                {!appliedCoupon ? (
                                                    <button
                                                        onClick={() => navigate("/Notifications")}
                                                        style={{
                                                            width: '100%',
                                                            padding: '12px',
                                                            backgroundColor: '#ee6521',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '10px',
                                                            cursor: 'pointer',
                                                            fontWeight: '600',
                                                            fontSize: '14px'
                                                        }}
                                                    >
                                                        Apply Coupon
                                                    </button>
                                                ) : (
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', backgroundColor: '#e8f5e9', borderRadius: '10px' }}>
                                                        <span style={{ color: '#22c55e', fontWeight: '500' }}>🎉 Coupon Applied! Saved ₹{discountAmount.toFixed(2)}</span>
                                                        <button onClick={handleRemoveCoupon} style={{ padding: '6px 14px', backgroundColor: '#dc2626', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>Remove</button>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Grand Total */}
                                            <div style={{ borderTop: '2px solid #ddd', margin: '16px 0', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 'bold' }}>
                                                <span>Grand Total</span>
                                                <span style={{ color: '#ee6521' }}>₹{grandTotal.toFixed(2)}</span>
                                            </div>

                                            {/* Order Type */}
                                            <select value={orderType} onChange={(e) => { setOrderType(e.target.value); if (e.target.value === 'DELIVERY' && !selectedAddressObj) setShowAddressPopup(true); }}
                                                style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #ddd', marginBottom: '12px', fontSize: '14px' }}>
                                                <option value="DELIVERY">🚚 Delivery</option>
                                                <option value="DINE_IN">🍽️ Dine In</option>
                                                <option value="TAKEAWAY">📦 Takeaway</option>
                                            </select>

                                            {/* Address Display */}
                                            {orderType === 'DELIVERY' && (
                                                <div onClick={() => setShowAddressPopup(true)} style={{ padding: '14px', backgroundColor: selectedAddressObj ? '#f0fdf4' : '#fff3e0', borderRadius: '10px', marginBottom: '12px', cursor: 'pointer', border: `1px solid ${selectedAddressObj ? '#22c55e' : '#ff9800'}` }}>
                                                    {selectedAddressObj ? (
                                                        <>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                                                <span>✅</span>
                                                                <span style={{ fontWeight: 'bold', color: '#22c55e' }}>Delivery Address Selected</span>
                                                            </div>
                                                            <div style={{ fontSize: '13px' }}>📍 {selectedAddressObj.address || selectedAddressObj.addressLine}</div>
                                                            {selectedAddressObj.name && <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>{selectedAddressObj.name} | {selectedAddressObj.phoneNumber}</div>}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span>⚠️</span>
                                                                <span style={{ fontWeight: 'bold', color: '#ff9800' }}>Add Delivery Address</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', marginTop: '4px' }}>Click to add delivery address</div>
                                                        </>
                                                    )}
                                                </div>
                                            )}

                                            {/* Action Buttons */}
                                            <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                                                <button onClick={openScheduleModal} disabled={showPaymentOptions}
                                                    style={{ flex: 1, padding: '12px', backgroundColor: '#fff', color: '#ee6521', border: '2px solid #ee6521', borderRadius: '30px', fontWeight: 'bold', cursor: showPaymentOptions ? 'not-allowed' : 'pointer', opacity: showPaymentOptions ? 0.6 : 1 }}>
                                                    📅 Schedule
                                                </button>
                                                {!showPaymentOptions ? (
                                                    <button onClick={() => { if (orderType === 'DELIVERY' && !selectedAddressObj) { toast.error("Please add delivery address"); setShowAddressPopup(true); return; } setShowPaymentOptions(true); }}
                                                        style={{ flex: 1, padding: '12px', backgroundColor: '#ee6521', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer' }}>
                                                        Checkout
                                                    </button>
                                                ) : (
                                                    <button onClick={() => setShowPaymentOptions(false)} style={{ flex: 1, padding: '12px', backgroundColor: '#6b7280', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer' }}>
                                                        Back
                                                    </button>
                                                )}
                                            </div>

                                            {/* Payment Options */}
                                            {showPaymentOptions && (
                                                <div style={{ marginTop: '16px' }}>
                                                    <div style={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '15px' }}>Select Payment Method</div>
                                                    {[
                                                        // { id: 'Cash', icon: '💵', label: 'Cash on Delivery' },
                                                        { id: 'Maamaas_Wallet', icon: '👛', label: `Wallet (₹${availableBalance.toFixed(2)})` },
                                                        { id: 'Online_Payment', icon: '💳', label: 'Online Payment' },
                                                    ].map(pm => (
                                                        <div key={pm.id} onClick={() => { setSelectedPaymentMethod(pm.id); if (pm.id !== 'Maamaas_Wallet') setSelectedwalletTypes(null); }}
                                                            style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px', borderRadius: '12px', marginBottom: '10px', cursor: 'pointer', border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#e5e7eb'}`, backgroundColor: selectedPaymentMethod === pm.id ? '#fff8f5' : '#fff' }}>
                                                            <span style={{ fontSize: '26px' }}>{pm.icon}</span>
                                                            <span style={{ flex: 1, fontSize: '14px', fontWeight: selectedPaymentMethod === pm.id ? '600' : '400' }}>{pm.label}</span>
                                                            <div style={{ width: '22px', height: '22px', borderRadius: '50%', border: `2px solid ${selectedPaymentMethod === pm.id ? '#ee6521' : '#ccc'}`, backgroundColor: selectedPaymentMethod === pm.id ? '#ee6521' : '#fff' }}></div>
                                                        </div>
                                                    ))}

                                                    {selectedPaymentMethod === 'Maamaas_Wallet' && (
                                                        <div style={{ marginTop: '12px', padding: '14px', backgroundColor: '#f9f9f9', borderRadius: '12px' }}>
                                                            <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Select Wallet Type:</div>
                                                            {[
                                                                { key: 'Self Loaded', label: 'Self Loaded', bal: availableSelf },
                                                                { key: 'Company Loaded', label: 'Company Loaded', bal: availableCompany },
                                                                { key: 'Cashback', label: 'Cashback', bal: availableCashback },
                                                            ].map(wt => (
                                                                <div key={wt.key} onClick={() => setSelectedwalletTypes(wt.key)}
                                                                    style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', borderRadius: '10px', marginBottom: '8px', cursor: 'pointer', backgroundColor: selectedwalletTypes === wt.key ? '#fff8f5' : '#fff', border: `1px solid ${selectedwalletTypes === wt.key ? '#ee6521' : '#ddd'}` }}>
                                                                    <span>{wt.label}</span>
                                                                    <span style={{ color: '#22c55e', fontWeight: 'bold' }}>₹{wt.bal.toFixed(2)}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    <button onClick={handlePlaceOrder} disabled={orderPlacing || !selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)}
                                                        style={{ width: '100%', padding: '14px', marginTop: '16px', backgroundColor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? '#ee6521' : '#ccc', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', fontSize: '15px', cursor: (selectedPaymentMethod && !(selectedPaymentMethod === 'Maamaas_Wallet' && !selectedwalletTypes)) ? 'pointer' : 'not-allowed' }}>
                                                        {orderPlacing ? '⏳ Placing Order...' : '🛒 Place Order'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* ==================== GST POPUP MODAL ==================== */}
            {showGstPopup && gstBreakdownData && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }} onClick={() => setShowGstPopup(false)}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '400px', position: 'relative' }} onClick={e => e.stopPropagation()}>
                        <button onClick={() => setShowGstPopup(false)} style={{ position: 'absolute', right: '16px', top: '16px', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
                        <h3 style={{ margin: '0 0 20px 0', color: '#ee6521' }}>GST Breakdown</h3>
                        <div>
                            {/* <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                <span>Total GST:</span>
                                <span style={{ color: '#ee6521' }}>₹{(gstBreakdownData.cgst + gstBreakdownData.sgst + gstBreakdownData.serviceChargeGst + gstBreakdownData.platformChargeGst).toFixed(2)}</span>
                            </div> */}
                            {gstBreakdownData.serviceChargeGst > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                    <span>Service Charge GST:</span>
                                    <span>₹{gstBreakdownData.serviceChargeGst.toFixed(2)}</span>
                                </div>
                            )}
                            {gstBreakdownData.platformChargeGst > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                    <span>Platform Charge GST:</span>
                                    <span>₹{gstBreakdownData.platformChargeGst.toFixed(2)}</span>
                                </div>
                            )}
                            {gstBreakdownData.cgst > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                    <span>CGST:</span>
                                    <span>₹{gstBreakdownData.cgst.toFixed(2)}</span>
                                </div>
                            )}
                            {gstBreakdownData.sgst > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                    <span>SGST:</span>
                                    <span>₹{gstBreakdownData.sgst.toFixed(2)}</span>
                                </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', fontWeight: 'bold', borderTop: '2px solid #ddd', marginTop: '8px' }}>
                                <span>Total GST:</span>
                                <span style={{ color: '#ee6521' }}>₹{(gstBreakdownData.cgst + gstBreakdownData.sgst + gstBreakdownData.serviceChargeGst + gstBreakdownData.platformChargeGst).toFixed(2)}</span>
                            </div>
                        </div>
                        <button onClick={() => setShowGstPopup(false)} style={{ width: '100%', padding: '12px', backgroundColor: '#ee6521', color: '#fff', border: 'none', borderRadius: '8px', marginTop: '20px', cursor: 'pointer' }}>Close</button>
                    </div>
                </div>
            )}

            {/* ==================== ADDRESS POPUP MODAL ==================== */}
            {showAddressPopup && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', width: '90%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto', padding: '20px', position: 'relative', scrollbarWidth: "none" }}>
                        <span onClick={() => { setShowAddressPopup(false); setShowAddAddressForm(false); }} style={{ position: 'absolute', right: '15px', top: '15px', fontSize: '20px', cursor: 'pointer' }}>✖</span>
                        <h3 style={{ margin: '0 0 20px 0', color: '#ee6521' }}>Select Delivery Address</h3>

                        <div style={{ position: "relative", width: "100%", marginBottom: "15px" }}>
                            <input type="text" ref={searchInputRef} placeholder="Search location..." style={{ width: "100%", padding: "10px 40px 10px 12px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "8px" }} />
                            <span onClick={() => { const query = searchInputRef.current?.value; if (query && window.google?.maps) { const geocoder = new window.google.maps.Geocoder(); geocoder.geocode({ address: query }, (results, status) => { if (status === "OK" && results[0]) { const location = results[0].geometry.location; moveMap(location.lat(), location.lng()); } else { alert("Location not found"); } }); } }} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}>🔍</span>
                        </div>

                        <div id="map" style={{ width: '100%', height: '250px', borderRadius: '12px', marginBottom: '15px' }}></div>

                        <button onClick={detectCurrentLocation} disabled={isLocating} style={{ width: '100%', padding: '12px', backgroundColor: '#ee6521', color: '#fff', border: 'none', borderRadius: '8px', marginBottom: '15px', cursor: 'pointer' }}>
                            {isLocating ? "Locating..." : "📍 Use My Current Location"}
                        </button>

                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                            <button onClick={() => setShowAddAddressForm(true)} style={{ padding: "8px 20px", backgroundColor: "#ee6521", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer" }}>+ Add New Address</button>
                        </div>

                        {showAddAddressForm && (
                            <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '12px', marginBottom: '15px' }}>
                                <div style={{ marginBottom: '10px' }}>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {['Home', 'Office', 'Other'].map(cat => (
                                            <button key={cat} onClick={() => setAddressForm({ ...addressForm, category: cat })} style={{ flex: 1, padding: '8px', backgroundColor: addressForm.category === cat ? '#ee6521' : '#f0f0f0', color: addressForm.category === cat ? '#fff' : '#333', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>{cat === 'Home' ? '🏠 Home' : cat === 'Office' ? '💼 Office' : '📍 Other'}</button>
                                        ))}
                                    </div>
                                </div>
                                <input type="text" placeholder="Door Number" value={addressForm.doorNumber} onChange={(e) => setAddressForm({ ...addressForm, doorNumber: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="Address Line" value={addressForm.addressLine} onChange={(e) => setAddressForm({ ...addressForm, addressLine: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="Landmark" value={addressForm.landMark} onChange={(e) => setAddressForm({ ...addressForm, landMark: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="City" value={addressForm.city} onChange={(e) => setAddressForm({ ...addressForm, city: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="State" value={addressForm.state} onChange={(e) => setAddressForm({ ...addressForm, state: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="number" placeholder="Pincode" value={addressForm.pincode} onChange={(e) => setAddressForm({ ...addressForm, pincode: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="Name" value={addressForm.name} onChange={(e) => setAddressForm({ ...addressForm, name: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <input type="text" placeholder="Phone Number" value={addressForm.phoneNumber} onChange={(e) => setAddressForm({ ...addressForm, phoneNumber: e.target.value })} style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                                <button onClick={submitNewAddress} style={{ width: '100%', padding: '10px', backgroundColor: '#22c55e', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Save Address</button>
                            </div>
                        )}

                        {addresses.map((a, i) => (
                            <div key={i} onClick={() => handleSavedAddressClick(a)} style={{ padding: '12px', border: `2px solid ${selectedAddressObj?.id === a.id ? '#ee6521' : '#e5e7eb'}`, borderRadius: '10px', marginBottom: '10px', cursor: 'pointer', backgroundColor: selectedAddressObj?.id === a.id ? '#fff8f5' : '#fff' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
                                    <span style={{ fontSize: '20px' }}>{a.category === 'Home' ? '🏠' : a.category === 'Office' ? '💼' : '📍'}</span>
                                    <b style={{ color: '#ee6521', flex: 1 }}>{a.category || 'Home'}</b>
                                    {selectedAddressObj?.id === a.id && <span style={{ color: '#22c55e', fontSize: '12px' }}>✓ Selected</span>}
                                </div>
                                <p style={{ margin: '5px 0 0', fontSize: '13px', color: '#555', marginLeft: '30px' }}>{a.address || a.addressLine}</p>
                                {a.name && <div style={{ marginLeft: '30px', marginTop: '5px', fontSize: '11px', color: '#888' }}>{a.name} | {a.phoneNumber}</div>}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Schedule Order Modal */}
            {isScheduleModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '400px' }}>
                        <h3 style={{ margin: '0 0 20px 0', color: '#ee6521' }}>Schedule Order</h3>
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', marginBottom: '8px' }}>Select Date</label>
                            <input type="date" value={scheduleDate} onChange={(e) => setScheduleDate(e.target.value)} min={new Date().toISOString().split("T")[0]} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                        </div>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ display: 'block', marginBottom: '8px' }}>Select Time</label>
                            <input type="time" value={scheduleTime} onChange={(e) => setScheduleTime(e.target.value)} style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }} />
                            <p style={{ fontSize: '11px', color: '#666', marginTop: '5px' }}>⏰ Schedule time must be at least 2 hours from now</p>
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button onClick={() => { setIsScheduleModalOpen(false); setScheduleDate(""); setScheduleTime(""); }} style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
                            <button onClick={handleScheduleConfirm} style={{ flex: 1, padding: '10px', backgroundColor: '#ee6521', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Confirm</button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
                @media (max-width: 768px) { 
                    .offers-containers { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; } 
                }
                @media (max-width: 480px) { 
                    .offers-containers { grid-template-columns: repeat(1, 1fr) !important; } 
                }
            `}</style>
        </div>
    );
};

export default MenuitemsTable;


